type BodyFields = {
	type: string;
	text?: string | null;
	transcription?: string | null;
	media_description?: string | null;
};

type MediaFields = {
	type: string;
	media_path?: string | null;
};

const MEDIA_TYPES = new Set(["audio", "image", "document", "video", "sticker"]);

export const MessageRender = {
	body(m: BodyFields): string {
		if (m.type === "unknown" && !m.text) {
			return "Conteúdo da mensagem indisponível";
		}

		if (m.type === "audio") {
			if (!m.transcription) {
				return "[audio]";
			}

			return m.transcription;
		}

		if (m.type === "template" && (!m.text || m.text.startsWith("[template:"))) {
			const saved = m.text?.match(/^\[template: ([^\]]*)\]\s*(.*)$/su);

			if (!saved) {
				return "Conteúdo do template indisponível";
			}

			const details = [`Conteúdo do template indisponível: ${saved[1]}`];

			if (saved[2]) {
				details.push(`Valores enviados: ${saved[2]}`);
			}

			return details.join("\n\n");
		}

		if (m.media_description) {
			return m.media_description.replaceAll(/\n+/gu, " ");
		}

		if (m.text) {
			if (m.text.trim() === "[unsupported]") {
				return "Mensagem nao suportada";
			}

			return m.text;
		}

		if (MEDIA_TYPES.has(m.type)) {
			return "[media]";
		}

		return `[${m.type}]`;
	},

	hasMedia(m: MediaFields): boolean {
		if (m.media_path) {
			return true;
		}

		return MEDIA_TYPES.has(m.type);
	},
};
